/**
 * Operations orders for the expansion's twenty-four missions (10 §2), by category: demolition (13-20),
 * intelligence (21-26), people (27-32), sabotage and endurance (33-36). Every rule in the design that can
 * lose a mission is stated in its order as an order, in words that match what the HUD repeats in play
 * (10 §1.1); tests/unit/uiBriefing.test.ts asserts a phrase from each.
 */

import type { ExpansionArchetypeId } from '../../../sim/types';
import type { ArchetypeOrder } from './orders';
import { DEMOLITION_ORDERS } from './ordersDemolition';
import { INTELLIGENCE_ORDERS } from './ordersIntelligence';
import { PEOPLE_ORDERS } from './ordersPeople';
import { SABOTAGE_ORDERS } from './ordersSabotage';

export const EXPANSION_ORDERS: Readonly<Record<ExpansionArchetypeId, ArchetypeOrder>> = {
  ...DEMOLITION_ORDERS, ...INTELLIGENCE_ORDERS, ...PEOPLE_ORDERS, ...SABOTAGE_ORDERS,
};
